import { type PostUserUserUserAuthenticationValidatePayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { postUserAuthenticationValidate } from '../data-access/api';

/**
 * @params 	PostUserUserUserAuthenticationValidatePayload
 * @returns user auth validation
 */
export const useUserAuthValidateMutation = () =>
	useMutation({
		mutationFn: (payload: PostUserUserUserAuthenticationValidatePayload) => postUserAuthenticationValidate(payload)
	});
